










































































import BaseComponent from '@/components/base-component.vue';
import AsyncProcessTable from '@/components/process/async-process-table.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiAutocomplePatients from '@/components/UI/autocomplete-patients.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import { PRESCRIPTIONS_MONTH_PDFS_TYPE } from '@/interfaces/async-process';
import { PrescricaoPDFsMesParmDTO } from '@/interfaces/prescriptions-month-pdfs';
import * as service from '@/services/prescriptions-month-pdfs';
import Component from 'vue-class-component';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiAutocompleClientsSubsidiaries,
    UiAutocomplePatients,
    UiSelectDoctor,
    AsyncProcessTable
  }
})
export default class PrescriptionsMonthPDFs extends BaseComponent {
  loading = false;
  clientUnit: any = null;
  idDoctor: any = null;
  idPatient: any = null;
  month: any = null;
  format = null;

  formats = [];
  months = [];

  processType = PRESCRIPTIONS_MONTH_PDFS_TYPE;
  versionUpdate = 0;

  public $refs!: {
    form: HTMLFormElement;
  };

  public form: any = {
    valid: false,
    rules: {
      clientUnit: [(v) => !!v || 'Escolha a Unidade Cliente'],
      month: [(v) => !!v || 'Escolha o Mês'],
      format: [(v) => !!v || 'Escolha o Formato']
    }
  };

  mounted() {
    this.listFormats();
    this.listMonths();
  }

  listFormats() {
    service.listPrescriptionPDFsMonthFormats().subscribe(
      (res) => {
        this.formats = res;
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }

  listMonths() {
    service.listPrescriptionPDFsMonthMonths().subscribe(
      (res) => {
        this.months = res;
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }

  exec() {
    this.loading = true;
    let dto = new PrescricaoPDFsMesParmDTO();
    dto.idUnidade = this.clientUnit.id;
    dto.mesAno = this.month;
    dto.formato = this.format;
    dto.idPaciente = this.idPatient;
    dto.idMedico = this.idDoctor;
    service.savePrescriptionPDFsMonth(dto).subscribe(
      (res) => {
        this.loading = false;
        this.toast.show(res, 'success');
        this.versionUpdate++;
      },
      (error) => {
        this.loading = false;
        this.showToastApiError(error);
      }
    );
  }
}
